// extracted by mini-css-extract-plugin
export var table = "_xt-0";